export const experts = [
  {
    id: 'b7a8bcc7-e651-41ff-bd69-b87fa1622290',
    name: 'Expert 1',
    completedModels: [
      {
        id: 'f88d74af-7073-4fb8-b33f-c45fe106791d',
        answers: [
          {
            answer: 'З 5 до 10 років',
            score: 20,
          },
          {
            answer: 'Виконавець',
            score: 20,
          },
          {
            answer: 'Магістр',
            score: 20,
          },
          {
            answer: 'Маловідома в ділових колах людина',
            score: 10,
          },
        ],
      },
      {
        id: '77f9edd8-e6b2-4af6-9e2c-22cf34e2a2fa',
        answers: [
          {
            answer: 'Високий',
            score: 40,
          },
          {
            answer: 'Високий',
            score: 40,
          },
          {
            answer: 'Середній',
            score: 20,
          },
          {
            answer: 'Високий',
            score: 50,
          },
          {
            answer: 'Високий',
            score: 50,
          },
        ],
      },
      {
        id: 'bd345cc7-9832-472a-9cbe-81672ee853a5',
        answers: [
          {
            answer: 'краще за інших відображає мої особисті погляди і досвід',
            score: 20,
          },
          {
            answer: 'зрозуміти мету і значення цього проекту',
            score: 5,
          },
          {
            answer: 'зрозуміти, наскільки вони подібні до звичних ідей',
            score: 25,
          },
          {
            answer: 'можливість виконання даних рекомендацій',
            score: 10,
          },
          {
            answer: 'чому це завдання варто вирішувати',
            score: 30,
          },
        ],
      },
    ],
  },
  {
    id: 'f4834ac0-91e5-4f55-aadf-b33c9a5c13d2',
    name: 'Expert 2',
    completedModels: [
      {
        id: 'f88d74af-7073-4fb8-b33f-c45fe106791d',
        answers: [
          {
            answer: 'Більше 10 років',
            score: 30,
          },
          {
            answer: 'Топ менеджер',
            score: 30,
          },
          {
            answer: 'Магістр',
            score: 20,
          },
          {
            answer: 'Маловідома в ділових колах людина',
            score: 10,
          },
        ],
      },
      {
        id: '77f9edd8-e6b2-4af6-9e2c-22cf34e2a2fa',
        answers: [
          {
            answer: 'Вище середнього',
            score: 30,
          },
          {
            answer: 'Вище середнього',
            score: 35,
          },
          {
            answer: 'Вище середнього',
            score: 25,
          },
          {
            answer: 'Низький',
            score: 10,
          },
          {
            answer: 'Низький',
            score: 10,
          },
        ],
      },
      {
        id: 'bd345cc7-9832-472a-9cbe-81672ee853a5',
        answers: [
          {
            answer: 'краще за інших відображає мої особисті погляди і досвід',
            score: 20,
          },
          {
            answer:
              'щоб робота над проектом була організована і зрушила з місця',
            score: 30,
          },
          {
            answer: 'протиставити їх іншим ідеям',
            score: 30,
          },
          {
            answer: 'можливість виконання даних рекомендацій',
            score: 10,
          },
          {
            answer: 'чому це завдання варто вирішувати',
            score: 30,
          },
        ],
      },
    ],
  },
  {
    id: 'a0bd92f4-8f71-4e62-b8d8-2d1ea9d2692b',
    name: 'Expert 3',
    completedModels: [
      {
        id: 'f88d74af-7073-4fb8-b33f-c45fe106791d',
        answers: [
          {
            answer: 'Більше 10 років',
            score: 30,
          },
          {
            answer: 'Топ менеджер',
            score: 30,
          },
          {
            answer: 'Доктор наук',
            score: 30,
          },
          {
            answer: 'Людина, визнана фахівцем в окремій галузі',
            score: 20,
          },
        ],
      },
      {
        id: '77f9edd8-e6b2-4af6-9e2c-22cf34e2a2fa',
        answers: [
          {
            answer: 'Високий',
            score: 40,
          },
          {
            answer: 'Високий',
            score: 40,
          },
          {
            answer: 'Високий',
            score: 40,
          },
          {
            answer: 'Середній',
            score: 20,
          },
          {
            answer: 'Вище середнього',
            score: 40,
          },
        ],
      },
      {
        id: 'bd345cc7-9832-472a-9cbe-81672ee853a5',
        answers: [
          {
            answer: 'викладає аргументи найбільш коротко і переконливо',
            score: 40,
          },
          {
            answer:
              'щоб робота над проектом була організована і зрушила з місця',
            score: 30,
          },
          {
            answer: 'протиставити їх іншим ідеям',
            score: 30,
          },
          {
            answer: 'можливість виконання даних рекомендацій',
            score: 10,
          },
          {
            answer: 'яка пряма, негайна користь від вирішення даного завдання',
            score: 40,
          },
        ],
      },
    ],
  },
  {
    id: '61bc857e-4a76-4156-88f7-3810539bd154',
    name: 'Expert 4',
    completedModels: [
      {
        id: 'f88d74af-7073-4fb8-b33f-c45fe106791d',
        answers: [
          {
            answer: 'З 5 до 10 років',
            score: 20,
          },
          {
            answer: 'Керівник вищої ланки',
            score: 25,
          },
          {
            answer: 'Магістр',
            score: 20,
          },
          {
            answer: 'Людина, визнана фахівцем в окремій галузі',
            score: 20,
          },
        ],
      },
      {
        id: '77f9edd8-e6b2-4af6-9e2c-22cf34e2a2fa',
        answers: [
          {
            answer: 'Високий',
            score: 40,
          },
          {
            answer: 'Високий',
            score: 40,
          },
          {
            answer: 'Середній',
            score: 20,
          },
          {
            answer: 'Високий',
            score: 50,
          },
          {
            answer: 'Високий',
            score: 50,
          },
        ],
      },
      {
        id: 'bd345cc7-9832-472a-9cbe-81672ee853a5',
        answers: [
          {
            answer: 'більше за інших зачіпає мої власні цінності та ідеали',
            score: 15,
          },
          {
            answer: 'зрозуміти мету і значення цього проекту',
            score: 5,
          },
          {
            answer: 'зосередитися на них і ретельно їх проаналізувати',
            score: 10,
          },
          {
            answer: 'можливість виконання даних рекомендацій',
            score: 10,
          },
          {
            answer: 'яка пряма, негайна користь від вирішення даного завдання',
            score: 40,
          },
        ],
      },
    ],
  },
  {
    id: '2d170fa3-2d62-41f9-b4b4-720559cf0eca',
    name: 'Expert 5',
    completedModels: [
      {
        id: 'f88d74af-7073-4fb8-b33f-c45fe106791d',
        answers: [
          {
            answer: 'Більше 10 років',
            score: 30,
          },
          {
            answer: 'Топ менеджер',
            score: 30,
          },
          {
            answer: 'Доктор наук',
            score: 30,
          },
          {
            answer: 'Людина, визнана фахівцем у кількох галузях',
            score: 25,
          },
        ],
      },
      {
        id: '77f9edd8-e6b2-4af6-9e2c-22cf34e2a2fa',
        answers: [
          {
            answer: 'Низький',
            score: 10,
          },
          {
            answer: 'Середній',
            score: 20,
          },
          {
            answer: 'Середній',
            score: 20,
          },
          {
            answer: 'Високий',
            score: 50,
          },
          {
            answer: 'Високий',
            score: 50,
          },
        ],
      },
      {
        id: 'bd345cc7-9832-472a-9cbe-81672ee853a5',
        answers: [
          {
            answer: 'викладає аргументи найбільш коротко і переконливо',
            score: 40,
          },
          {
            answer:
              'щоб робота над проектом була організована і зрушила з місця',
            score: 30,
          },
          {
            answer: 'протиставити їх іншим ідеям',
            score: 30,
          },
          {
            answer: 'розуміння автором цілей та завдань роботи',
            score: 40,
          },
          {
            answer: 'чому це завдання варто вирішувати',
            score: 30,
          },
        ],
      },
    ],
  },
];
